<template>
    <div class="headContent center">
        <div class="headBox between">
            <el-image :src="require('@/assets/icon/logo.png')" fit="cover" class="logo" @click="logoTap"></el-image>
        <!-- <el-image :src="logoImg" fit="cover" class="logoName" @click="logoTap"></el-image> -->
            <div class="headTopNavList align">
                <div :class="['headTopNavBox column',active == index && !isMy ? 'headTopNavBoxOn' : '']" v-for="(item,index) in headTab" :key="index" class="headTopNavBox column" @click="headTabTap(index,item.id)">
                    <div class="headTopNav">{{ item.name }}</div>
                    <div class="headTopNavIcon"></div>
                </div>
            </div>
            <!-- <div class="headTopLogin" @click="getLogin">{{ userId == '0' ? '进入开放平台' : '退出登录' }}</div> -->
            <div class="headRecord">收藏记录</div>
            <el-image :src="require('@/assets/image/loginBg.jpg')" fit="cover" style="width:0;height:0;position: fixed;left: -100px;top: -100px;"></el-image>
        </div>
    </div>
</template>
<script>
    import { EventBus } from '@/common/js/eventBus.js';
    export default {
        data(){
            return{
                userId: 0,
                logoImg: '',
                headData: {},
                headTab: [],
                active: 0,
                isMy: false
            }
        },
        watch:{
            $route(to,from){
                if(from.path == '/login/login'){
                    this.userId = localStorage.getItem("userId") || 0
                }
                this.isMy = to.path == '/my/my' ? true : false
                console.log(to.path)
                console.log(this.isMy)
            }
        },
        created() {
            
        },
        mounted(){
            console.log
            this.userId = localStorage.getItem("userId") || 0
            // this.getAppLogo()
            this.getHeadTab()
        },
        methods: {
            // 网站logo
            getAppLogo(){
                this.request.get("api/index/pclogo",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.logoImg = res.data
                })
            },
            // 网站头tab
            getHeadTab(){
                this.request.get("index/index/cate1",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    let obj = res.data
                    this.headTab = obj
                    this.headTabTap(0,obj[0].id)
                })
            },
            // logo点击
            logoTap(){
                this.$router.push({ path:'/' })
            },
            // 登录/退出登录
            getLogin(){
                if(this.userId == '0'){
                    this.$router.push({ path:'/login/login', query:{router: 'union'} })
                }else{
                    localStorage.removeItem('userId')
                    this.$router.go(0)
                }
            },
            // tab切换
            headTabTap(e,i){
                console.log('tab')
                this.active = e
                setTimeout(() => {
                    EventBus.$emit('headTabTap',e,i)
                }, 100);
            },
        }
    }
</script>
<style lang="less" scoped>
    .headContent{
        width: 100vw;
        height: 80px;
        background: #fff;
        .headBox{
            width: 1232px;
            height: 80px;
            .headTopLogo{
                width: 54px;
                height: 54px;
                cursor: pointer;
            }
            .logo{
                width: auto;
                height: 54px;
                cursor: pointer;
            }
            .logoName{
                width: auto;
                height: 54px;
                margin-left: 8px;
                cursor: pointer;
            }
            .headTopNavList{
                flex: 1;
                .headTopNavBox{
                    min-width: 48px;
                    height: 50px;
                    padding-top: 4px;
                    margin-left: 44px;
                    cursor: pointer;
                    &:hover{
                        color: #FF6146;
                    }
                    .headTopNav{
                        font: 16px/46px "Microsoft YaHei";
                    }
                    .headTopNavIcon{
                        width: 48px;
                        height: 4px;
                        border-radius: 2px;
                    }
                }
                .headTopNavBoxOn{
                    .headTopNavIcon{
                        background: #FF6146;
                    }
                }
            }
            .headTopLogin{
                width: 132px;
                height: 38px;
                background: #FF601C;
                border-radius: 4px;
                font: 14px/38px "Microsoft YaHei";
                color: #fff;
                text-align: center;
                cursor: pointer;
            }
            .headRecord{
                font: 14px/54px "Microsoft YaHei";
                color: #47474F;
                cursor: pointer;
                &:hover{
                    color: #FF6146;
                }
            }
        }
    }
</style>